import { addDays, addHours } from 'date-fns';

import { Frame, State } from 'features/Frames/types';
import { DATE } from 'mocks/server/utils/constants';
export const frames: Frame[] = [
  // Example: MIA
  {
    id: '1000000000',
    name: 'Cardiff Central Station, Central Square, Cardiff',
    displayUnitId: '20000000000',
    broadsignFrameId: '3000000000',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.MIA,
      time: DATE.toISOString(),
    },
  },
  // Example: Missing fields
  {
    id: '',
    name: '',
    displayUnitId: '',
    broadsignFrameId: '',
    publisher: '',
    environment: '',
    formatSize: '',
    resolution: '',
    status: {
      state: State.MIA,
      time: addHours(DATE, 1).toISOString(),
    },
  },
  // Example: In error & Really long fields
  {
    id: '1000000001',
    name: 'This is a very long name to show an example of how the app deals with really long names',
    displayUnitId: '9f1c7234-52ba-49c6-ae3d-8226b0a95375',
    broadsignFrameId: '3000000001',
    publisher: 'All City Media Solutions',
    environment: 'MotorwayServiceStation',
    formatSize: 'StreetHub',
    resolution: '1080x1920',
    status: {
      state: State.IN_ERROR,
      time: addDays(DATE, 10).toISOString(),
    },
  },
  // Example: Ok
  {
    id: '1000000002',
    name: 'Cardiff Central Station, Central Square, Cardiff 2',
    displayUnitId: '20000000002',
    broadsignFrameId: '3000000002',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.OK,
      time: DATE.toISOString(),
    },
  },
  // Example: Ok missing display unit ID
  {
    id: '1000000012',
    name: 'Cardiff Central Station, Central Square, Cardiff 3',
    displayUnitId: '',
    broadsignFrameId: '3000000012',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.OK,
      time: DATE.toISOString(),
    },
  },
  // Example: Ok missing broadsign frame ID
  {
    id: '1000000013',
    name: 'Cardiff Central Station, Central Square, Cardiff 4',
    displayUnitId: '20000000013',
    broadsignFrameId: '',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.OK,
      time: DATE.toISOString(),
    },
  },
  // Example: Ok with leader ID
  {
    id: '1000000014',
    name: 'Cardiff Central Station, Central Square, Cardiff 5',
    displayUnitId: '20000000014',
    broadsignFrameId: '3000000014',
    leader: 'leaderId',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.OK,
      time: DATE.toISOString(),
    },
  },
  // Example: Deactivated
  {
    id: '1000000003',
    name: 'Cardiff Central Station, Central Square, Cardiff 3',
    displayUnitId: '20000000003',
    broadsignFrameId: '3000000003',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.DEACTIVATED,
      time: DATE.toISOString(),
    },
  },
  // Example: Low delivery
  {
    id: '1000000004',
    name: 'Cardiff Central Station, Central Square, Cardiff 4',
    displayUnitId: '20000000004',
    broadsignFrameId: '3000000004',
    publisher: 'Global',
    environment: 'UndergroundStation',
    formatSize: 'D6',
    resolution: '1080x1920',
    status: {
      state: State.LOW_DELIVERY,
      time: DATE.toISOString(),
    },
  },
];
